import React, { useState } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Reports() {
  const [tab, setTab]       = useState('attendance');
  const [data, setData]     = useState([]);
  const [loading, setLoading] = useState(false);
  const today   = new Date().toISOString().split('T')[0];
  const month   = today.slice(0,7);

  const [filters, setFilters] = useState({ from: month+'-01', to: today, month });
  const setF = k => e => setFilters(f => ({...f, [k]: e.target.value}));

  const fetch = async () => {
    setLoading(true);
    try {
      let res;
      if (tab === 'attendance') {
        res = await api.get(`/reports/attendance?from=${filters.from}&to=${filters.to}`);
      } else if (tab === 'overtime') {
        res = await api.get(`/reports/overtime?from=${filters.from}&to=${filters.to}`);
      } else {
        res = await api.get(`/reports/payroll?month=${filters.month}`);
        setData(res.data.data); setLoading(false); return;
      }
      setData(res.data);
    } catch (err) {
      toast.error('Failed to fetch report');
    } finally { setLoading(false); }
  };

  const exportExcel = async () => {
    try {
      const params = tab === 'payroll'
        ? `type=payroll&month=${filters.month}`
        : `type=${tab}&from=${filters.from}&to=${filters.to}`;
      const res = await api.get(`/reports/export?${params}`, { responseType:'blob' });
      const url = URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `report_${tab}_${filters.month||filters.from}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success('Excel downloaded');
    } catch (err) { toast.error('Export failed'); }
  };

  const TabBtn = ({ id, label }) => (
    <button className={`btn ${tab===id?'btn-primary':'btn-outline'}`}
      onClick={() => { setTab(id); setData([]); }}>
      {label}
    </button>
  );

  return (
    <div>
      <h1 className="page-title">Reports</h1>

      <div className="flex gap-8 mb-16">
        <TabBtn id="attendance" label="Attendance"/>
        <TabBtn id="overtime"   label="Overtime"/>
        <TabBtn id="payroll"    label="Payroll"/>
      </div>

      <div className="card mb-16">
        <div className="flex gap-8" style={{alignItems:'flex-end',flexWrap:'wrap'}}>
          {tab !== 'payroll' ? (
            <>
              <div className="form-group" style={{margin:0}}>
                <label className="form-label">From</label>
                <input className="form-control" type="date" value={filters.from} onChange={setF('from')}/>
              </div>
              <div className="form-group" style={{margin:0}}>
                <label className="form-label">To</label>
                <input className="form-control" type="date" value={filters.to} onChange={setF('to')}/>
              </div>
            </>
          ) : (
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Month</label>
              <input className="form-control" type="month" value={filters.month} onChange={setF('month')}/>
            </div>
          )}
          <button className="btn btn-primary" onClick={fetch} disabled={loading}>
            {loading ? 'Loading...' : 'Generate Report'}
          </button>
          {data.length > 0 && (
            <button className="btn btn-outline" onClick={exportExcel}>
              ⬇ Export Excel
            </button>
          )}
        </div>
      </div>

      {data.length > 0 && (
        <div className="card">
          <div className="card-title" style={{marginBottom:12}}>
            {data.length} records found
          </div>
          <div className="table-wrap">
            {tab === 'attendance' && (
              <table>
                <thead><tr><th>Employee</th><th>Department</th><th>Date</th><th>Check In</th><th>Check Out</th><th>Regular Hrs</th><th>Overtime</th><th>WFH</th><th>Status</th></tr></thead>
                <tbody>
                  {data.map((r,i) => (
                    <tr key={i}>
                      <td>{r.full_name}</td>
                      <td>{r.department||'—'}</td>
                      <td>{new Date(r.date).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}</td>
                      <td>{r.check_in ? new Date(r.check_in).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}) : '—'}</td>
                      <td>{r.check_out ? new Date(r.check_out).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}) : '—'}</td>
                      <td>{r.regular_hours||0}h</td>
                      <td>{r.overtime_hours > 0 ? `+${r.overtime_hours}h` : '—'}</td>
                      <td>{r.is_wfh ? '✓' : '—'}</td>
                      <td><span className={`badge ${r.status==='present'?'badge-green':r.status==='absent'?'badge-red':'badge-blue'}`}>{r.status}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {tab === 'overtime' && (
              <table>
                <thead><tr><th>Employee</th><th>Department</th><th>Total Overtime Hrs</th><th>Days with Overtime</th></tr></thead>
                <tbody>
                  {data.map((r,i) => (
                    <tr key={i}>
                      <td style={{fontWeight:500}}>{r.full_name}</td>
                      <td>{r.department||'—'}</td>
                      <td style={{color:'var(--success)',fontWeight:600}}>{parseFloat(r.total_overtime||0).toFixed(2)}h</td>
                      <td>{r.days_with_overtime}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {tab === 'payroll' && (
              <table>
                <thead><tr><th>Employee</th><th>Department</th><th>Days Present</th><th>Days on Leave</th><th>WFH Days</th><th>Regular Hrs</th><th>Overtime Hrs</th></tr></thead>
                <tbody>
                  {data.map((r,i) => (
                    <tr key={i}>
                      <td style={{fontWeight:500}}>{r.full_name}</td>
                      <td>{r.department||'—'}</td>
                      <td>{r.days_present||0}</td>
                      <td>{r.days_leave||0}</td>
                      <td>{r.days_wfh||0}</td>
                      <td>{parseFloat(r.total_regular_hours||0).toFixed(1)}h</td>
                      <td style={{color:'var(--success)',fontWeight:600}}>{parseFloat(r.total_overtime_hours||0).toFixed(1)}h</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {data.length === 0 && !loading && (
        <div className="card">
          <div className="empty-state">
            <div className="icon">📊</div>
            <p>Set filters above and click <strong>Generate Report</strong></p>
          </div>
        </div>
      )}
    </div>
  );
}
